<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="stockinout" />
        <MenuStockList/>
        <AllLotList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import AllLotList from '@/components/menuadmin/stock/stocklist/AllLotList.vue'

export default {
    name:'allLot',
    components:{
        HeaderStock,
        MenuStockList,
        AllLotList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>